import clsx from 'clsx';
import { DeepMap, FieldError, FieldValues } from 'react-hook-form';
import { useIntl } from 'react-intl';
import ReactSelect from 'react-select';

type SelectOption = {
	value: string;
	label: string;
};

type SelectProps = {
	name?: string;
	value: SelectOption | Array<SelectOption>;
	title?: string;
	options: Array<SelectOption>;
	defaultValue?: SelectOption | Array<SelectOption>;
	onChange: (options) => void;
	onInputChange?: (inputChange: string) => void;
	isLoading?: boolean;
	isDisabled?: boolean;
	isClearable?: boolean;
	isSearchable?: boolean;
	isMulti?: boolean;
	required?: boolean;
	errors?: DeepMap<FieldValues, FieldError>;
	responsiveTitle?: boolean;
	filtersTitle?: boolean;
	loginTitle?: boolean;
	horizontalSelect?: boolean;
	horizontalPhone?: boolean;
	styles?: any;
};

const Select: React.FC<SelectProps> = ({
	name,
	value,
	isMulti,
	isDisabled,
	isSearchable,
	isClearable,
	onChange,
	title,
	options,
	defaultValue,
	onInputChange,
	isLoading,
	errors,
	required = false,
	responsiveTitle = false,
	filtersTitle = false,
	loginTitle = false,
	horizontalSelect = false,
	horizontalPhone = false,
	styles,
}) => {
	const intl = useIntl();

	return (
		<div className={clsx({ 'row align-items-center': horizontalSelect })} onClick={(e) => e.stopPropagation()}>
			{!horizontalPhone && title && (
				<div className={clsx({ 'col-12 col-sm-3': horizontalSelect })}>
					<div
						className={clsx('', {
							'form-label pb-3 mb-0 fs-7 fw-bold': !loginTitle,
							'pt-5 pt-sm-0': responsiveTitle,
							'py-3': filtersTitle,
							'fw-bolder text-dark fs-6 pb-0 mb-2': loginTitle,
							required: required,
						})}
					>
						{title}
					</div>
				</div>
			)}

			<div className={clsx({ 'col-12 col-sm-9': horizontalSelect })}>
				<ReactSelect
					options={options}
					defaultValue={defaultValue}
					value={value}
					onChange={onChange}
					onInputChange={onInputChange}
					isLoading={isLoading}
					styles={styles}
					closeMenuOnSelect={true}
					isMulti={isMulti}
					isDisabled={isDisabled}
					isClearable={isClearable}
					isSearchable={isSearchable}
					className="fs-6 fw-bold"
					placeholder={intl.formatMessage({ id: 'PLACEHOLDER.SELECT' })}
					menuPortalTarget={document.body} // Render the dropdown to the body
				/>
			</div>
		</div>
	);
};

export default Select;

export type { SelectOption, SelectProps };
